import $ from "jquery";
import c from "common";

var $body = $(document.body);

function getUserFromDOM() {
  var $loginHeader = $(".login-header");
  var services = ($body.attr('data-services') || "").split(" ");
  var credentialsId = $body.attr('data-credentialsId') || undefined;
  if (credentialsId) {
    credentialsId = parseInt(credentialsId, 10);
  }
  return {
    "username": $loginHeader.attr('data-username'),
    "entertainmentCredentialsId": credentialsId,
    "cookiePermission": $body.attr('data-cookiePermission'),
    "termsAccepted": $body.hasClass('termsAccepted'),
    "stronglyIdentified": $body.hasClass('stronglyIdentified'),
    "emailVerified": $body.hasClass('emailVerified'),
    "email": $loginHeader.attr('data-email'),
    "marketingConsent": $loginHeader.attr('data-marketing-consent'),
    "emailIsForBilling": $loginHeader.attr('data-email-is-for-billing') === 'true',
    "preview": $body.hasClass("preview"),
    "services": services,
    "hasNetpvr": c.contains(services, "netpvr"),
    "hasViihdeOnline": c.contains(services, "viihdeonline"),
    "isImpersonated": $loginHeader.hasClass('elisaid-impersonated'),
    "bearerToken": $loginHeader.attr('data-bearer'),
    "elisaIdAuthenticated": $loginHeader.hasClass('elisaid-authenticated'),
    "elisaIdAccountId": $loginHeader.attr('data-elisa-id-account-id'),
    "ecList": parseEcList($loginHeader.attr('data-eclist')),
  };
}

function parseEcList(string) {
  return string ? JSON.parse(string) : {};
}

function getAnalyticsUserGroup() {
  var credentialsId = getUserFromDOM().entertainmentCredentialsId,
    userGroup = "";

  if (credentialsId) {
    userGroup = credentialsId % 2 === 0 ? 1 : 2;
  }

  return userGroup;
}

export default {
  fromDOM: getUserFromDOM,
  getAnalyticsUserGroup: getAnalyticsUserGroup
};



// WEBPACK FOOTER //
// ./web/js/user.js